import React from 'react';
import PropTypes from 'prop-types';
import Col from 'base-ui/dist/Col';
import Container from 'base-ui/dist/Container';
import Row from 'base-ui/dist/Row';

import MenuItem from 'components/Layout/_shared/Menu/MenuItem';

export default function SubMenuGroup({ items }) {
  const handleCreateSubMenuGrouped = (item) => (
    <Col xs="4" key={item.ID}>
      <span className="title">
        <a href={item.link}>{item.title}</a>
      </span>
      <ul>
        {item.children
        && item.children.map((itemIterable) => <MenuItem key={itemIterable.ID} item={itemIterable} />)}
      </ul>
    </Col>
  );

  return (
    <ul className="sub-menu links">
      <Container fluid wrap>
        <Row>
          { items && items.map((item) => handleCreateSubMenuGrouped(item)) }
        </Row>
      </Container>
    </ul>
  );
}

SubMenuGroup.propTypes = {
  items: PropTypes.array
};
